import { APIResponse, MediaCategory, queryRequiredAccess } from '@cbgms/api'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export interface SupportPostMediaParams {
  companyUUID: string
  subCategory: string
  category: MediaCategory
  file: File
}

export interface SupportMediaParams {
  category: MediaCategory
  companyUUID?: string
  subCategory?: string
  fileName?: string
}

export interface SupportMediaOutput {
  FileName: string
  ContentType: string
  Data: string
}

export interface SupportMediaList {
  Objects: SupportMediaOutput[]
}

export interface SupportMediaItemResponse {
  PublicURL: string
  RelativePath: string
  RelativeThumbPath: string
  SizeInBytes: number
  Success: boolean
}

export type ListSupportMediaResponse = APIResponse<SupportMediaList>

export const postMediaItemRequest = ({ companyUUID, file, subCategory, category }: SupportPostMediaParams) => {
  const access = queryRequiredAccess(category)
  const url = subCategory
    ? `/modules/media/${access}/${companyUUID}/${category}/${subCategory}/${file.name}`
    : `/modules/media/${access}/${companyUUID}/${category}/${file.name}`
  return {
    method: 'GET',
    url,
    data: file
  }
}

export const postMediaItem = ({ companyUUID, file, subCategory, category }: SupportPostMediaParams) => {
  return createAsyncApiAction<APIResponse<SupportMediaItemResponse>>('support', {
    method: 'POST',
    url: `/modules/media/private/${companyUUID}/${category}/${subCategory}/${file.name}`,
    data: file
  })
}

export const getMediaItemRequest = ({ category, companyUUID, subCategory, fileName }: SupportMediaParams) => {
  const access = queryRequiredAccess(category)
  const url = subCategory
    ? `/modules/media/${access}/${companyUUID}/${category}/${subCategory}/${fileName}`
    : `/modules/media/${access}/${companyUUID}/${category}/${fileName}`
  return {
    method: 'GET',
    url
  }
}
